import React, { useEffect } from 'react';
import { Navbar } from './Navbar';
import { Hero } from './Hero';
import { Stats } from './Stats';
import { CountdownTimer } from './CountdownTimer';
import { Testimonials } from './Testimonials';
import { ProblemSection } from './ProblemSection';
import { ProductHero } from './ProductHero';
import { Modules } from './Modules';
import { Bonuses } from './Bonuses';
import { Pricing } from './Pricing';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { FloatingNotification } from './FloatingNotification';
import { CTAButton } from './CTAButton';
export function LandingPage() {
  useEffect(() => {
    // FB Pixel Init
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('init', '1313291250496067');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen" data-id="element-79">
      <Navbar data-id="element-80" />
      <Hero data-id="element-81" />
      <Stats data-id="element-82" />
      <CountdownTimer data-id="element-83" />
      <Testimonials data-id="element-84" />
      <ProblemSection data-id="element-85" />
      <ProductHero data-id="element-86" />
      <Modules data-id="element-87" />
      <Bonuses data-id="element-88" />
      <Pricing data-id="element-89" />

      {/* Guarantee Section */}
      <section className="bg-[#2D9B6F] py-8 md:py-12 text-center text-white" data-id="element-90">
        <div className="container mx-auto px-4" data-id="element-91">
          <div className="max-w-3xl mx-auto" data-id="element-92">
            <div className="text-6xl mb-4" data-id="element-93">🔒</div>
            <h2 className="font-poppins font-black text-3xl md:text-5xl mb-4" data-id="element-94">
              GARANTÍA DE 7 DÍAS
            </h2>
            <p className="text-xl leading-relaxed" data-id="element-95">
              Si abrís el pack y sentís que no es para vos, te devolvemos el
              100% de tu dinero. Sin preguntas, sin vueltas. Tu inversión está
              totalmente protegida.
            </p>
          </div>
        </div>
      </section>

      <FAQ data-id="element-96" />

      {/* Final CTA */}
      <section className="bg-[#1B3A6B] py-8 md:py-12 lg:py-[60px] text-center text-white" data-id="element-97">
        <div className="container mx-auto px-4" data-id="element-98">
          <h2 className="font-poppins font-black text-3xl md:text-6xl mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-99">
            ¿Lista/o para transformar la convivencia en tu escuela?
          </h2>
          <CTAButton href="#pricing" className="mx-auto" data-id="element-100">
            SÍ, QUIERO EL PACK COMPLETO
          </CTAButton>
        </div>
      </section>

      <Footer data-id="element-101" />
      <FloatingNotification data-id="element-102" />
    </div>;
}